<template>
  <div class2="container-fluid pt-3">
    <video id="beepElementId" src="https://api.klingo.app/message.ogg" style="display: none;" ></video>

    <p class="alert alert-warning" v-if="status">{{ status }}</p>
    <p class="alert alert-light d-flex justify-content-between py-1 mb-1" v-else-if="painel">
      <span>
        <span class="lead">{{ painel.search }}</span>
        <span class="lead" v-if="nome_recepcao">
          <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
          {{ nome_recepcao }}
        </span>
        <span class="lead" v-if="filtro_local">
          <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
          <span class="small text-muted">{{ filtro_local }}</span>
        </span>
      </span>
      <span>
        <span class="badge badget-secondary mr-3" v-if="info_tempo">
          {{ info_tempo }}
        </span>
        <i class="fas fa-volume-up mr-2" v-if="tipo_som == 'S'"></i>
        <i class="fas fa-microphone-alt mr-2" v-if="tipo_som == 'V'"></i>
        <button class="btn btn-outline-primary btn-sm" type="button">
          <i class="fas fa-sync-alt"></i>
        </button>
        <button class="btn btn-outline-primary btn-sm ml-1" type="button" v-if="iniciado" @click="reiniciar()">
          <i class="fa-solid fa-chevron-left"></i>
        </button>
      </span>
    </p>

    <div class="row">
      <div class="col col-12">
        <div v-if="status" class="d-flex justify-content-center align-items-center">
          <az-empty-state :msg="status" icon="fa fa-bug" />
        </div>

        <div v-else-if="!iniciado" class="mx-3">
          <div class="d-flex flex-column mt-2">
            <button type="button" class="btn btn-lg btn-dark mb-3" @click="tipo_som = 'S'; iniciado = true">
              <i class="fas fa-volume-up mr-2"></i>
              Clique Aqui para Iniciar o Painel com Aviso Sonoro
            </button>
          </div>

          <div class="d-flex flex-column">
            <button type="button" class="btn btn-lg btn-info mb-3" @click="tipo_som = 'V'; iniciado = true">
              <i class="fas fa-microphone-alt mr-2"></i>
              Clique Aqui para Iniciar o Painel com Chamada de Voz
            </button>
          </div>

          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <input type="checkbox" aria-label="Checkbox for following text input" v-model="manter_pos_iniciar">
              </div>
            </div>
            <label class="form-control">Não retirar o paciente do painel ao inciar o atendimento</label>
          </div>

          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <input type="checkbox" aria-label="Checkbox for following text input" v-model="com_video">
              </div>
            </div>
            <label class="form-control">Espaço pra Vídeo</label>
          </div>

          <div class="form-group" v-if="com_video">
            <label for="exampleInputEmail1" class="small mb-0">Código do Vídeo do Youtube (EMBED)</label>
            <input type="email" class="form-control" id="exampleInputEmail1" v-model="codigo_video">
            <small id="emailHelp" class="form-text text-muted">Código do Vídeo no Youtube... 
              Para ver o código deve se clicar em compartilhar, e selecionar a opção "EMBED"
            </small>
          </div>

          <div class="form-row">
            <div class="col col-12 col-md-6">
              <az-input 
                  label="Cor nome do paciente"
                  type="color" 
                  placeholder="Padrão..."
                  v-model="cores.paciente" />
            </div>
            <div class="col col-12 col-md-6">
              <az-input 
                  label="Cor local de chamada"
                  type="color" 
                  placeholder="Padrão..."
                  v-model="cores.local" />
            </div>
          </div>

          <div v-if="$refs.voz">
            <az-input
              label="Voz"
              type="select"
              :optionsList="$refs.voz.getVoices()"
              optionsData="id"
              v-model="selvoz" />
          </div>

          <div class="form-row">
            <div class="col col-12 col-md-6">
                <az-input
                    label="Filtrar Local (Deixe em branco para todos)"
                    placeholder="Todos... (Exemplo: Sala)"
                    v-model="filtro_local" />

                <div class="small text-muted" v-if="filtro_local">
                    Somente serão chamadas nesse painel, as chamadas cujo local iniciem com "<strong>{{ filtro_local }}</strong>".<br>
                    Se houver mais de um local, separar por vírgula. (Exemplo: Sala,Consultorio)
                </div>
            </div>
            <div class="col col-12 col-md-6">
                <az-input
                    label="Tempo de Duração da Chamada em segundos (Mínimo 3 e Máximo 30)"
                    type="number"
                    :min="3"
                    :max="30"
                    v-model="info_tempo" />
            </div>
          </div>
          
        </div>

        <template v-else>

          <div class="text-white atalho text-nowrap text-truncate pb-1 px-3" :class="cores.paciente ? '' : 'bg-primary'" :style="cores.paciente ? 'background-color: ' + cores.paciente : ''">
            <h4 v-if="!com_video" class="mb-0 mt-2">Paciente</h4>
            <span class="display-3">
              <span title="Atendimento Preferencial" v-if="currentPref">
                <i class="fab fa-product-hunt text-white ml-1" ></i>
              </span>

              {{currentPaciente}} &nbsp;
            </span>
          </div>

          <div class="text-white atalho text-nowrap text-truncate pb-2 px-3" :class="cores.local ? '' : 'bg-danger'" :style="cores.local ? 'background-color: ' + cores.local : ''">
            <h4 v-if="!com_video" class="mb-0 mt-2">Local</h4>
            <span class="display-4 mb-2">
              <span v-if="!block_profissional">{{currentMedico}}</span>
              <span v-if="!block_profissional && currentMedico && currentLocal">
                <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
              </span>
              <span>{{currentLocal}}</span>
              &nbsp;
            </span>
          </div>

          <table class="table table-sm mb-0" v-if="false">
            <tr>
              <td>

                <div class="row">
                  <div class="col col-12 text-nowrap text-truncate">
                    <div class="card border-0 card-templates shadow-lg card-link">
                      <div class="card-body text-white atalho bg-primary">
                        <h4 class="mb-0">Paciente</h4>
                        <div class="border-bottom display-3">
                          <div class="row">
                            <div class="col col-12 text-nowrap text-truncate">
                              <span title="Atendimento Preferencial" v-if="currentPref">
                                <i class="fab fa-product-hunt text-white ml-1" ></i>
                              </span>
                              {{currentPaciente}} &nbsp;
                            </div>
                          </div>
                          
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">

                    <div class="card border-0 card-templates shadow-lg card-link">
                      <div
                        class="card-body d-flex flex-column text-white atalho bg-danger"
                      >
                        <h4 class="mb-0">Local</h4>
                        <div class="border-bottom display-4">
                          <span v-if="!block_profissional">{{currentMedico}}</span>
                          <span v-if="!block_profissional && currentMedico && currentLocal">
                            <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                          </span>
                          <span>{{currentLocal}}</span>
                          &nbsp;
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </td>
              
            </tr>
          </table>

          <table class="table table-sm">
            <tr>
              <td>
                <div v-if="com_video">
                  <table class="table table-striped table-sm table-responsive-md table-light">
                    <thead>
                      <tr>
                        <th>Paciente</th>
                        <th>Destino</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(chamada, indice) in chamadas">
                        <tr :key="indice">
                          <td class="h3">
                            <span data-toggle="tooltip" data-placement="top" title="Atendimento Preferencial" v-if="chamada.pref">
                              <i class="fab fa-product-hunt ml-1" ></i>
                            </span>
                            {{chamada.paciente}}
                          </td>
                          <td class="h5">
                            <div class="text-nowrap" v-if="!block_profissional">{{chamada.medico}}</div>
                            <div class="text-nowrap">{{chamada.local}}</div>
                            <div class="small text-muted">{{chamada.horario}}</div>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>

                <div v-else>
                  <table class="table table-striped table-sm table-responsive-md table-light">
                    <thead>
                      <tr>
                        <th>Paciente</th>
                        <th v-if="!block_profissional">Profissional</th>
                        <th>Sala</th>
                        <th>Horário</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(chamada, indice) in chamadas">
                        <tr :key="indice">
                          <td class="h2">
                            <span data-toggle="tooltip" data-placement="top" title="Atendimento Preferencial" v-if="chamada.pref">
                              <i class="fab fa-product-hunt ml-1" ></i>
                            </span>
                            {{chamada.paciente}}
                          </td>
                          <td class="h2" v-if="!block_profissional">{{chamada.medico}}</td>
                          <td class="h2">{{chamada.local}}</td>
                          <td class="text-nowrap ">{{chamada.horario}}</td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </td>

              <td v-if="com_video" class="bg-white altura-video p-0">
                <div class="embed-responsive embed-responsive-16by9 border-1 bg-secondary">
                  <!-- + '?controls=0' -->
                  <div v-if="codigo_video" id="video-loader"></div>
                </div>
              </td>
            </tr>
          </table>

          <!--
            <div class="embed-responsive embed-responsive-16by9 border-1">
                  <iframe v-if="codigo_video" class="embed-responsive-item" :src="'https://www.youtube.com/embed/' + codigo_video + '?controls=0'" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                </div>
                -->

          
          <!--
          <div class="form-row">
            <div class="col col-12 col-md-4" v-if="com_video">
              <table class="table table-striped table-sm table-responsive-md table-light">
                <thead>
                  <tr>
                    <th>Paciente</th>
                    <th>Destino</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(chamada, indice) in chamadas">
                    <tr :key="indice">
                      <td class="h3">{{chamada.paciente}}</td>
                      <td class="h5">
                        <div class="text-nowrap">{{chamada.medico}}</div>
                        <div class="text-nowrap">{{chamada.local}}</div>
                        <div class="small text-muted">{{chamada.horario}}</div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>

            <div class="col col-12" v-else>
              <table class="table table-striped table-sm table-responsive-md table-light">
                <thead>
                  <tr>
                    <th>Paciente</th>
                    <th>Profissional</th>
                    <th>Sala</th>
                    <th>Horário</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(chamada, indice) in chamadas">
                    <tr :key="indice">
                      <td class="h2">{{chamada.paciente}}</td>
                      <td class="text-nowrap h2">{{chamada.medico}}</td>
                      <td class="text-nowrap h2">{{chamada.local}}</td>
                      <td class="text-nowrap ">{{chamada.horario}}</td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>

            <div class="col col-12 col-md-8 bg-white" v-if="com_video">
              <div class="embed-responsive embed-responsive-16by9 border-1">
                <iframe v-if="codigo_video" class="embed-responsive-item" :src="'https://www.youtube.com/embed/' + codigo_video + '?controls=0'" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
              </div>
            </div>
            
          </div>

            -->

        </template>
          
      </div>
    </div>

    <chamada-voz ref="voz" :selvoz="selvoz" /> <!-- v-if="tipo_som == 'V'"  -->

    <div class="card panel-fullscreen" v-show="em_chamada && timeout">
      <div class="card-body d-flex flex-column justify-content-center h-100">
        <div class="display-1 text-center mb-0">
          <span title="Atendimento Preferencial" v-if="currentPref">
            <i class="fab fa-product-hunt text-white ml-1" ></i>
          </span>
          <big class="font-weight-bold">
            {{ currentPaciente }}
          </big>
        </div>

        <hr>

        <div class="text-center">
          <div class="display-4" v-if="!block_profissional">{{currentMedico}}</div>
          <div class="display-2">{{currentLocal}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AzEmptyState from "../util/AzEmptyState.vue";
import { subscribe } from "../../service/Notify";
import { setTimeout, clearTimeout } from 'timers';
import ChamadaVoz from './ChamadaVoz.vue';
import AzInput from '../shared/forms/AzInput.vue';

export default {
  data() {
    return {
      painel: null, 
      chamadas: [],
      currentPaciente: "",
      currentPref: false, 
      currentMedico: "",
      currentLocal: "", 
      currentAtendimento: "", 
      status: "Carregando...",
      painelToken: "",
      painelUnidade: "",
      link: "",
      tempo: 0,
      timeout: null, 
      iniciado: false, 
      nome_recepcao: null, 
      tipo_som: "", 
      com_video: false, 
      codigo_video: "", 
      cores: { 
        paciente: "", 
        local: "",
      },
      selvoz: "", 
      em_chamada: false, 
      manter_pos_iniciar: false,
      player: null,
      block_profissional: false, 
      info_tempo: 5, 
      filtro_local: "", 
    };
  },

  components: {
    AzEmptyState,
    AzInput, 
    ChamadaVoz
  },

  props: ["token", "unidade", "video", "codigo"],

  watch: { 
    iniciado: function () { 
      this.$util.setCookie('pnl-video', this.com_video ? 'S' : 'N');
      this.$util.setCookie('pnl-codigo-video', this.codigo_video);
      this.$util.setCookie('pnl-cor-nome', this.cores.paciente ? this.cores.paciente : '');
      this.$util.setCookie('pnl-cor-local', this.cores.local ? this.cores.local : '');
      this.$util.setCookie('pnl-mpi', this.manter_pos_iniciar ? 'S' : 'N');
      this.$util.setCookie('pnl-tempo', this.info_tempo);
      this.$util.setCookie('pnl-local', this.filtro_local);

      if ( !this.player ) { 
        this.loadYouTubeAPI();
      } else { 
        this.player = null;

        this.$nextTick(() => { 
          this.initializePlayer(true);
        })
      }
    }
  },

  methods: {
    tratar_codigo (codigo) { 
      if ( codigo.indexOf('&') >= 0 ) { 
        codigo = codigo.replace('&', '?');
      }

      codigo = codigo + ( codigo.indexOf('?') > 0 ? '&' : '?' ) + 'autoplay=1&loop=1&controls=0';
      codigo = 'https://www.youtube.com/embed/' + codigo;

      return codigo;
    },

    reiniciar () { 
      this.iniciado = false;
    },

    retirar(data) { 

      if ( this.manter_pos_iniciar ) 
        return;

      if ( this.currentAtendimento == data.id_marcacao ) { 
        this.currentPaciente = "";
        this.currentPref = false;
        this.currentMedico = "";
        this.currentLocal = "";
        this.currentAtendimento = "";
      }

      let index = this.chamadas.findIndex(item => item.id_marcacao == data.id_marcacao);

      if ( index >= 0 ) { 
        this.chamadas.splice(index,1);
        this.retirar(data);
      }

    },

    chamarPaciente(data) {

        let tempo_chamada = ( this.info_tempo && this.info_tempo >= 3 && this.info_tempo <= 30 ) ? this.info_tempo * 1000 : 5000;

        setTimeout(() => {

            let secundaria = "";

            // Validação da Unidade
            if ( data.id_recepcao && this.painelUnidade && data.id_recepcao != this.painelUnidade ) { 
                if ( data.ids_recepcao && data.ids_recepcao.find(item => item == this.painelUnidade) ) { 
                    // chamada em recepção secundária...
                    secundaria = "*";
                } else { 
                    return;
                }
            }

            //

            if ( this.filtro_local ) { 

                let filtros = this.filtro_local.split(",").map(item => item.trim().toLowerCase());

                if ( data.local && filtros.find(filtro => data.local.toLowerCase().startsWith(filtro) ) ) { 
                    // ok
                } else { 
                    console.log("Chamada de outro local: ", data.local);
                    return;
                }

            }

            //

            if ( process.env.VUE_APP_GTAG ) { 

            let action = 'painel-chamada';
            let label = data.id_marcacao;
            
            this.$gtag.event(action, {
                'event_category': window.redir,
                'event_label': label,
                'value': 1
            });

            }

            this.currentPaciente = data.paciente;
            this.currentPref = data.pref;
            this.currentMedico = data.medico;
            this.currentLocal = data.local + secundaria;
            this.currentAtendimento = data.id_marcacao;

            this.em_chamada = true;
            
            this.chamadas.unshift({
            paciente: data.paciente,
            pref: data.pref, 
            medico: data.medico,
            horario: this.$util.agora(),
            local: data.local + secundaria, 
            id_atendimento: data.id_atendimento, 
            id_marcacao: data.id_marcacao, 
            });

            // this.beep2();
            if ( this.tipo_som == 'V' ) { 
            
            let texto = data.paciente.toLowerCase();

            if ( data.local ) { 
                texto = texto + ', ' + data.local;
            }

            //pause video white falar(teto);
            this.pauseVideo();
            this.$refs.voz.falar(texto);

            } else { 

            this.beep();

            }
            
            // verificar se tem mais de 5 chamados e excluir o ultimo
            if (this.chamadas && this.chamadas.length > 5) {
            this.chamadas.splice(-1, 1);
            }

            this.tempo = tempo_chamada;
            
            if ( this.timeout ) { 
            clearTimeout(this.timeout);
            }

            this.timeout = setTimeout(() => {
            this.tempo = 0;
            this.timeout = null;
            this.em_chamada = false;
            if(this.tipo_som == 'V') {
                this.playVideo();
            }
            }, tempo_chamada + 1000);
            
        }, this.tempo);

    },

    tratarNotificacao(data) { 

      if ( this.iniciado && !data.block_painel ) { 

        switch (data.acao) {
          case 'chamar':
            this.chamarPaciente(data);
            break;

          case 'chamar_para_recepcao':
            data.medico = 'Recepção';
            this.chamarPaciente(data);
            break;

          case 'iniciar':
            this.retirar(data);
            break;
        
        }

      }

    },

    assinar() { 

      subscribe(this.$store.state.dominio, "chamar-paciente", retorno => {
        this.tratarNotificacao(retorno.data);
      });

    },

    beep() {
      const el = document.getElementById("beepElementId");
      el.play();

        // var snd = new Audio("data:audio/wav;base64,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");  
        // snd.play();
    },

    beep2() { 
      let som = document.getElementById('som');

      if ( som ) { 
        som.play();
        som.muted = false;
      }
    },

    loadYouTubeAPI() {

      if(this.player || !this.codigo_video) {
        // this.player.destroy();
        //player já carregado
        return;
      }

      var tag = document.createElement('script');
      tag.src = "//www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      tag.onload = () => {
        this.initializePlayer();
      };
    },

    initializePlayer(refresh = false) {
      let codigo = this.codigo_video;
      let playlist = ""; 

      if ( codigo.slice(0,4) == 'http' ) { 
        
        // Example URL
        const url = codigo;

        // Create a URL object
        const urlObj = new URL(url);

        // Use URLSearchParams to extract the query string parameters
        const params = new URLSearchParams(urlObj.search);

        if ( params.get('list') ) { 
          playlist = params.get('list');
          codigo = ""; 
        } 

        if ( params.get('v') ) {  
          codigo = params.get('v');
        }

      } else { 

        if ( codigo.slice(0,1) == '!' ) { 
          playlist = codigo.slice(1);
          codigo = ""; 
        }

      }

      //

      let info = {
        playerVars: {
          autoplay: 1,
          loop: 1, 
          showinfo: 0,
          autohide: 1,
          // controls: 0,
        },
        events: {
          'onReady': this.onPlayerReady,
        }
      };

      if ( playlist ) { 
        info.playerVars.listType = 'playlist';
        info.playerVars.list = playlist; 
        info.playerVars.playlist = playlist; 
      } 
      
      if ( codigo ) { 
        info.videoId = codigo;
        
        if ( !playlist ) { 
          info.playerVars.playlist = codigo; 
        }
      }

      //accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen
      if ( refresh ) { 
        this.player = new window.YT.Player('video-loader', info);
      } else { 
        window.onYouTubeIframeAPIReady = () => {
          this.player = new window.YT.Player('video-loader', info);
        };
      }
    },

    onPlayerReady(event) {
      this.player = event.target;
    },

    playVideo() {
      if (this.player) {
        this.player.playVideo();
      }
    },
    pauseVideo() {
      if (this.player) {
        this.player.pauseVideo();
      }
    }

  },

  beforeMount() { 
    if ( this.video ) { 
      this.com_video = this.video == 'S' ? true : false;  
    } else { 
      this.com_video = this.$util.getCookie('pnl-video') == 'S' ? true : false;
    }

    this.manter_pos_iniciar = this.$util.getCookie('pnl-mpi') == 'S' ? true : false;

    if ( this.codigo ) { 
      this.codigo_video = this.codigo; 
    } else {   
      this.codigo_video = this.$util.getCookie('pnl-codigo-video');
    }

    this.cores.paciente = this.$util.getCookie('pnl-cor-nome');
    this.cores.local = this.$util.getCookie('pnl-cor-local');

    this.info_tempo = this.$util.getCookie('pnl-tempo') ? parseInt(this.$util.getCookie('pnl-tempo')) : 5;
    this.filtro_local = this.$util.getCookie('pnl-local', "");
  },


  beforeDestroy() { 
    // window.Echo.leaveChannel(dominio);
  },

  mounted() {
    if ( process.env.VUE_APP_GTAG ) { 
      this.$gtag.set({'dimension2': 'painel'});
    }

    this.painelToken = this.token;
    this.painelUnidade = this.unidade ? this.unidade : 1;

    this.$router.replace({ name: "painel-chamada" });

    this.$store.commit("loading", true);

    this.axios
      .get("/chamada/" + this.painelToken + "/" + this.painelUnidade)
      .then(res => {
        if ( res.response && res.response.status > 400 ) { 
          this.status = res.response.data;
          this.$toast.add({
            severity: "error",
            summary: "Atenção",
            detail: res.response.data,
            life: 3000
          });
        } else { 
          this.status = "";
          this.painel = res.data.unidade_operacao;
          this.link = res.data.link;
          this.nome_recepcao = res.data.nome_recepcao;
          this.block_profissional = res.data.block_profissional;

          this.assinar();
        }
       
      })
      .catch(err => { 
        alert (err);
      })
      .finally(() => {
        this.$store.commit("loading", false);
      });

  }
};
</script>

<style scoped>
.altura-video {
  width: calc( ( 100vh - 200px ) * ( 16 / 9 ) ); 
  width: -o-calc( ( 100vh - 200px ) * ( 16 / 9 ) ); /* opera */
  width: -webkit-calc( ( 100vh - 200px ) * ( 16 / 9 ) ); /* google, safari */
  width: -moz-calc( ( 100vh - 200px ) * ( 16 / 9 ) ); /* firefox */

  height: calc(100vh - 200px);
  height: -o-calc(100vh - 200px); /* opera */
  height: -webkit-calc(100vh - 200px); /* google, safari */
  height: -moz-calc(100vh - 200px); /* firefox */
}

.panel-fullscreen {
  display: block;
  z-index: 1031;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  overflow: auto;
}
</style>